module.exports = __webpack_public_path__ + "img/banner.de78c2e0.png";